export default __webpack_public_path__ + "static/media/solutionBGRight.b4b178dd.svg";